import React from "react";
import Employee from "../../models/employee";

const CashRegisterContext = React.createContext({
  currentEmployee: new Employee(),
  setEmployee: (employee: Employee) => {},
  handleShift: () => {},
});
export default CashRegisterContext;
